<template>
  <b-container class="video-player-container">
    <b-embed
      class="video-frame"
      type="iframe"
      aspect="16by9"
      :src="videoUrl"
      allowfullscreen
      title="Dropsmart Video Content"
    ></b-embed>
  </b-container>
</template>

<script>
// import { h } from "vue";

export default {
  name: "DefaultVideoComponent",
  props: ["videoUrl"],
};
</script>

<style scoped lang="scss">
.video-player-container {
  padding: 0;
}
.embed-responsive, .embed-responsive-16by9 {
  border-radius: 2rem;
  background-color: white;
}
</style>
